import React from 'react';
import { WebsiteDesignProps } from './types';
import { Sun, Wind, Cloud } from 'lucide-react';
import { Button } from "@/components/ui/button";

const BohoChic: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Wildflower Kindy";

    return (
        <div className="bg-[#fcf8e3] text-[#5c5040] min-h-screen font-sans">
             {/* Textures */}
             <div className="fixed inset-0 pointer-events-none opacity-50" style={{backgroundImage: 'url("https://www.transparenttextures.com/patterns/beige-paper.png")'}}></div>

             <nav className="relative z-10 p-8 flex justify-center items-center border-b border-[#e6dcc6]">
                 <div className="flex flex-col items-center">
                     <div className="w-16 h-16 rounded-full bg-[#dccfac] flex items-center justify-center mb-2">
                         <Sun className="text-white fill-white/50" size={32} />
                     </div>
                     <h1 className="text-2xl font-serif italic tracking-wide text-[#8c7860]">{schoolName}</h1>
                 </div>
             </nav>

             <main className="container mx-auto px-8 py-16 relative z-10">
                 <div className="flex flex-col md:flex-row gap-16 items-center">
                     <div className="md:w-1/2">
                         <div className="relative">
                             <div className="absolute top-0 left-0 w-full h-full border border-[#d2b48c] transform translate-x-4 translate-y-4 rounded-t-full"></div>
                             <img src="https://images.unsplash.com/photo-1596908906666-ac967c9454f9?q=80&w=2070&auto=format&fit=crop" className="w-full relative z-10 rounded-t-full sepia-[.3]" alt="Boho Kid" />
                         </div>
                     </div>
                     
                     <div className="md:w-1/2 text-center md:text-left">
                         <h2 className="text-5xl md:text-7xl font-serif text-[#a68a64] mb-8 leading-tight">
                             Free <span className="italic">Spirited</span> <br/> Learning.
                         </h2>
                         <p className="text-lg text-[#8c7860] leading-loose mb-10 font-light">
                             We embrace the natural rhythms of childhood. Earth tones, natural materials, and open-ended play define our gentle approach.
                         </p>
                         <Button variant="outline" className="rounded-full border-[#a68a64] text-[#a68a64] hover:bg-[#a68a64] hover:text-white px-10 py-6 uppercase tracking-widest text-xs transition-all">
                             Our Philosophy
                         </Button>
                     </div>
                 </div>

                 <div className="mt-24 flex justify-around items-center border-t border-[#e6dcc6] pt-12">
                     <div className="text-center">
                         <Wind className="mx-auto mb-2 text-[#d2b48c]" />
                         <span className="font-serif italic text-[#8c7860]">Breathe</span>
                     </div>
                     <div className="w-px h-12 bg-[#e6dcc6]"></div>
                     <div className="text-center">
                         <Sun className="mx-auto mb-2 text-[#d2b48c]" />
                         <span className="font-serif italic text-[#8c7860]">Shine</span>
                     </div>
                     <div className="w-px h-12 bg-[#e6dcc6]"></div>
                     <div className="text-center">
                         <Cloud className="mx-auto mb-2 text-[#d2b48c]" />
                         <span className="font-serif italic text-[#8c7860]">Dream</span>
                     </div>
                 </div>
            </main>
        </div>
    );
};

export default BohoChic;
